import { handleTrackingButtonOnClick } from "./index";

export default function PrimaryButton({
  text,
  onClick,
  size,
  style,
  disabled,
}: any) {
  let px = "px-3";
  let py = "py-2";

  switch (size) {
    case "sm":
      px = "px-2.5";
      py = "py-1.5";
      break;

    case "lg":
      px = "px-4";
      py = "py-2";
      break;

    default:
      break;
  }

  return (
    <>
      <button
        type="button"
        className={`inline-flex items-center ${px} ${py} rounded border border-transparent focus:outline-none  ${
          disabled ? "bg-[#CACACA]" : "bg-indigo-600"
        } ${
          !disabled && "hover:bg-indigo-700"
        }  text-button font-button text-white shadow-sm  focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
        onClick={() => handleTrackingButtonOnClick(text, onClick)}
        style={style}
        disabled={disabled}
      >
        {text}
      </button>
    </>
  );
}
